import {
  SET_DATE_ACT,
} from './actions.type';
import { SET_DATE } from './mutations.type';

export default {
  [SET_DATE_ACT](context, dateSelection) {
    context.commit(SET_DATE, dateSelection);
  },
};
